import { call, put, takeLatest } from "redux-saga/effects";
import {
  getAllClassPeriodTeacherscheduleRequest,
  getAllClassPeriodTeacherscheduleSuccess,
  getAllClassPeriodTeacherscheduleFailure,
} from "./classPeriodTeacherscheduleSlice"; 
import { getAllClassPeriodTeacherscheduleMapping } from "../../api/ClassPeriods/GetAllClassPeriodTeacherscheduleService";

function* fetchClassPeriodTeacherscheduleSaga(action) {
  try {
    const {formData} = action.payload;
    const response = yield call(getAllClassPeriodTeacherscheduleMapping, formData);
    yield put(getAllClassPeriodTeacherscheduleSuccess(response?.data)); 
  } catch (error) {
    yield put(getAllClassPeriodTeacherscheduleSuccess([])); 
    // yield put(getClassPeriodsFailure(error.message || "Something went wrong"));
  }
}

export default function* watchClassPeriodTeacherschedule() {
  yield takeLatest(getAllClassPeriodTeacherscheduleRequest.type, fetchClassPeriodTeacherscheduleSaga);
}

